import { t } from '@/i18n';
import type { Column, MobileConfig } from '@chikara/ui';

export const DASHBOARD_ITEMS_PER_PAGE = 10;

export const DASHBOARD_MOVEMENT_COLUMNS: Column[] = [
  { key: 'email', label: t('dashboard.table.email'), width: '18%' },
  { key: 'cdate', label: t('dashboard.table.date'), width: '15%', align: 'center' },
  { key: 'movement', label: t('dashboard.table.movement'), width: '33%' },
  { key: 'amount', label: t('dashboard.table.amount'), width: '12%', align: 'right' },
  { key: 'type', label: t('dashboard.table.type'), width: '10%' },
  { key: 'status', label: t('dashboard.table.status'), width: '12%' },
  { key: 'cdate_mobile', label: t('dashboard.table.date'), isMobile: true },
  { key: 'pan_masked', label: t('dashboard.table.pan_masked'), isMobile: true },
];

export const DASHBOARD_MOVEMENT_MOBILE_CONFIG: MobileConfig = {
  primaryField: 'movement_mobile',
  expandableFields: ['email', 'cdate_mobile', 'pan_masked', 'amount', 'type', 'status'],
};

export const STATUS_TRANSACTION: Record<string, string> = {
  approved: 'Aprobada',
  on_transit: 'En Tránsito',
  settled: 'Liquidada',
  reversed: 'Reversada',
  failed: 'Fallida',
  unsettled: 'No Liquidada',
  declined: 'Rechazada',
}

export const TYPE_TRANSACTION: Record<string, string> = {
  'tx.ab': 'Abono',
  'tx.cr': 'Cargo',
}
